import { BRSR_BASE_PATH } from '../../config/brsrConfig'
import { BRSR_QUESTIONS } from '../../data/brsr/questions'
import type { AnswerMap, BrsrResult, BrsrStepId } from '../../data/brsr/types'
import { isQuestionVisible } from './visibility'

export function validateStep(step: BrsrStepId, responses: AnswerMap): string[] {
  const errors: string[] = []
  for (const question of BRSR_QUESTIONS) {
    if (question.stage !== step || !question.required || !isQuestionVisible(question, responses)) continue
    const value = responses[question.id]
    const empty = value == null || value === '' || (Array.isArray(value) && value.length === 0)
    if (empty) errors.push(`Please answer: ${question.label}`)
  }
  return errors
}

export function validateLead(input: {
  fullName: string
  workEmail: string
  companyName: string
  jobTitle: string
  consentContact: boolean
}): string[] {
  const errors: string[] = []
  if (!input.fullName.trim()) errors.push('Name is required.')
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.workEmail.trim())) errors.push('A valid business email is required.')
  if (!input.companyName.trim()) errors.push('Company is required.')
  if (!input.consentContact) errors.push('Consent is required to download the PDF.')
  return errors
}

export function validatePdfInput(result: BrsrResult | null): string[] {
  if (!result) return ['Complete the assessment before generating a report.']
  const errors: string[] = []
  if (!result.assessedAt) errors.push('Assessment date is missing.')
  if (!result.financialYearLabel) errors.push('Reporting year is missing.')
  if (!result.applicability) errors.push('Applicability assessment is missing.')
  if (!result.dimensions?.length) errors.push('Dimension scores are missing.')
  if (!result.overall) errors.push('Overall result is missing.')
  if (result.companyName.trim() === '') errors.push('Company name placeholder is missing.')
  return errors
}

export function pdfFileName(result: BrsrResult): string {
  const company = result.companyName.replace(/[^\w]+/g, '-').replace(/^-|-$/g, '') || 'Assessment'
  const year = result.financialYearLabel.replace(/\s+/g, '')
  return `EcopsHub-BRSR-Readiness-${company}-${year}.pdf`
}

export const BRSR_TOOL_URL = `https://ecopshub.com${BRSR_BASE_PATH}`
